"use client";

import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import React, { useEffect, useState } from "react";
import OrganizationForm from "./OrganizationForm";
import OrganizationTable from "./OrganizationTable";
import OwnerGroup from "../components/OwnerGroup";
import { useGlobalState } from "../utils/GlobalStateContext";
import { Box, Typography } from "@mui/material";

function Organizations() {
  const { state: globalState, dispatch } = useGlobalState();
  const { ownerGroups } = globalState;

  const [open, setOpen] = useState(false);

  const [ownerGroup, setOwnerGroup] = useState();

  useEffect(() => {
    if (ownerGroups && ownerGroups.length > 0) {
      setOwnerGroup(ownerGroups[0].id);
    }
  }, [ownerGroups]);

  const handleOwnerGroupChange = (event) => {
    setOwnerGroup(event.target.value);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Paper elevation={6}>
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            gap: 3,
            alignItems: "center",
            justifyContent: "start",
            mb: 5,
            ml: "auto",
            minHeight: 80,
          }}
        >
          <Typography variant="h5" sx={{ ml: 5 }}>
            My Organizations
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              ml: "auto",
              gap: 2,
            }}
          >
            <Typography sx={{ height: 28 }}>Select Owner Group</Typography>
            <OwnerGroup
              handleSelection={handleOwnerGroupChange}
              selectedValue={ownerGroup}
              options={ownerGroups}
            />
            <Button
              variant="contained"
              onClick={handleClickOpen}
              sx={{ ml: 2 }}
              startIcon={<AddIcon />}
            >
              Create New Organization
            </Button>
          </Box>
        </Box>
      </Paper>
      <OrganizationTable ownerGroup={ownerGroup} />
      <OrganizationForm
        open={open}
        handleClose={handleClose}
        isNewOrganization={true}
        ownerGroup={ownerGroup}
      />
    </>
  );
}

export default Organizations;
